export default __webpack_public_path__ + "static/media/shotguns.527bde02.svg";